import { render, staticRenderFns } from "./AppointmentPanel.vue?vue&type=template&id=c84ce740&scoped=true&"
import script from "./AppointmentPanel.vue?vue&type=script&lang=js&"
export * from "./AppointmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentPanel.vue?vue&type=style&index=0&id=c84ce740&prod&scoped=true&lang=css&"
import style1 from "./AppointmentPanel.vue?vue&type=style&index=1&id=c84ce740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ce740",
  null
  
)

export default component.exports